module.exports = __webpack_public_path__ + "static/img/11.bcba0b0.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/3/eng/11.png
// module id = 8HEu
// module chunks = 0